// extracted by mini-css-extract-plugin
export default {"app_about":"app_about_app_about__F1aSS","text":"app_about_text__z-7DY"};